import React from 'react';
import * as _ from 'lodash';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import Caption from '../Caption';
import Tooltip from '../Tooltip';
import styles from './Timeline.module.css';

const bindClasses = classNameBind.bind(styles);

class Timeline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refsList: this.prepareRefs(props.items),
      items: props.items,
      paddings: {},
    };
  }

  static getDerivedStateFromProps(props, state) {
    const prepareRefs = (items) => {
      const refsList = {};
      for (let i = 0; i < items.length; i++) {
        const current = items[i];
        refsList[current.id] = React.createRef();
      }

      return refsList;
    };
    if (!_.isEqual(state.items, props.items)) {
      return {
        refsList: prepareRefs(props.items),
        items: props.items,
      };
    }

    return null;
  }

  componentDidMount() {
    this.preparePaddingsObject(this.state.refsList);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.items, this.props.items) || (_.isEmpty(this.state.paddings) && this.props.items.length > 0)) {
      this.preparePaddingsObject(this.state.refsList);
    }
  }

  preparePaddingsObject = (refsList) => {
    const obj = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const id of Object.keys(refsList)) {
      obj[id] = refsList[id].current.clientHeight;
    }
    this.setState({ paddings: obj });
  }

  // eslint-disable-next-line consistent-return
  prepareRefs = (items) => {
    const refsList = {};
    for (let i = 0; i < items.length; i++) {
      const current = items[i];
      refsList[current.id] = React.createRef();
    }

    return refsList;
  }

  render() {
    const {
      items,
      dateOnRight,
    } = this.props;
    const {
      refsList,
      paddings,
    } = this.state;

    return (
      <div className={bindClasses('wrapper', { dateOnRight })}>
        {items.map((item, i) => (
          <React.Fragment key={item.id}>
            {!dateOnRight && (
            <div className={bindClasses('left')}>
              {item.dateTooltip ? (
                <Tooltip content={item.dateTooltip}>
                  <div style={{ paddingTop: dateOnRight ? 4 : _.get(paddings, item.id, 0) / 2 - 3 }}>
                    <Caption subdued>
                      {item.date}
                    </Caption>
                  </div>
                </Tooltip>
              ) : (
                <div style={{ paddingTop: dateOnRight ? 4 : _.get(paddings, item.id, 0) / 2 - 3 }}>
                  <Caption subdued>
                    {item.date}
                  </Caption>
                </div>
              )}
            </div>
            )}
            <div className={bindClasses('center')}>
              <div ref={refsList[item.id]}>
                <Icon
                  filled={!item.icon.invertedFill}
                  invertedFill={item.icon.invertedFill}
                  color={item.icon.color}
                  name={item.icon.name}
                  badge={item.icon.badge}
                  fillSize={item.icon.fillSize}
                  size={item.icon.size}
                />
              </div>
              {i < items.length - 1 && <div className={bindClasses('line')} />}
            </div>
            <div className={bindClasses('right', { dateOnRight })}>
              {dateOnRight && (
              <div className={bindClasses('left', { dateOnRight })}>
                {item.dateTooltip ? (
                  <Tooltip content={item.dateTooltip}>
                    <div style={{ paddingTop: dateOnRight ? 4 : _.get(paddings, item.id, 0) / 2 - 3 }}>
                      <Caption subdued>
                        {item.date}
                      </Caption>
                    </div>
                  </Tooltip>
                ) : (
                  <div style={{ paddingTop: dateOnRight ? 4 : _.get(paddings, item.id, 0) / 2 - 3 }}>
                    <Caption subdued>
                      {item.date}
                    </Caption>
                  </div>
                )}
              </div>
              )}
              {item.description}
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

Timeline.defaultProps = {
  dateOnRight: false,
};

export default Timeline;
